export const localizationsFields = `
  localizations: _localizations {
    typename: __typename
    locale: _locale
    slug: _slug
  }
`;
